// [qrToken] QR Token encode/decode utilities
// Dual format support:
//   's.<base64url>'  = static (new format — matches mobile app)
//   '<base64>'       = legacy static (backward compat)

function toBase64Url(input) {
  return btoa(unescape(encodeURIComponent(input)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

// [qrToken] Encode static QR token with "s." prefix — matches mobile app format
export function encodeQrToken({ slug, zoneId, tableId }) {
  const payload = JSON.stringify({ slug, zoneId, tableId })
  return 's.' + toBase64Url(payload)
}

// [qrToken] Alias for new call sites
export const encodeStaticQrToken = encodeQrToken

// [qrToken] Decode static QR token — supports both new "s." and legacy base64
export function decodeQrToken(token) {
  if (!token || typeof token !== 'string') return null
  try {
    if (token.startsWith('s.')) {
      const b64 = token.slice(2).replace(/-/g, '+').replace(/_/g, '/')
      const padLen = (4 - (b64.length % 4)) % 4
      const json = decodeURIComponent(escape(atob(b64 + '='.repeat(padLen))))
      const parsed = JSON.parse(json)
      if (!parsed.slug || !parsed.zoneId || !parsed.tableId) return null
      return { slug: String(parsed.slug), zoneId: Number(parsed.zoneId), tableId: Number(parsed.tableId) }
    }
    // [qrToken] Legacy format — plain base64 JSON
    const parsed = JSON.parse(atob(token))
    if (!parsed.slug || !parsed.zoneId || !parsed.tableId) return null
    return { slug: String(parsed.slug), zoneId: Number(parsed.zoneId), tableId: Number(parsed.tableId) }
  } catch {
    return null
  }
}
// =====================[QrToken]=====================
